
export default {
  props: {
    imgSrc: {
      type: String,
      default: require(`~/assets/img/j-icon.svg`),
    },
  },
};
